const FULL_DEAL_ORGANIZATION_IDS = [
  // prod
  '6734b6ec375990002a1a1dab',
  '5e5fbbef55e6a6001b03fab6', // moneyman,
  // dev
  '6734bd79c81ca8002bccbe4e',
  '6745922fc7a5e60029c5b780',
  '6734b8eba871da0027300346',
];
const SRAVNI_ORGANIZATION_OFFERS = ['6745922fc7a5e60029c5b780', '6734b8eba871da0027300346', '6734bd79c81ca8002bccbe4e'];

export const isFullDealOrganization = (id: string) => FULL_DEAL_ORGANIZATION_IDS.includes(id);

/**
 *  проверяет офер от Получи-Заем (Сравни) ?
 * @param id
 * @returns true если
 */
export const isSravniOffer = (id: string) => SRAVNI_ORGANIZATION_OFFERS.includes(id);
